import Vue from 'vue';
import App from './App.vue';
import './utils/polyfill';
// import appConfig from './config';
import JSSDK from '@zm-fe/zm-jssdk';
import router from './router';
// import store from './store';
import http from './utils/http';
import track from '@utils/track';
import * as api from './api';
import * as utils from '@utils';
import Alert from '@zmComponents/zm-alert';
import Loading from '@zmComponents/zm-loading';
// import 'amfe-flexible';
import 'intersection-observer'; // IntersectionObserver/polyfill

import './assets/css/g.scss';

// 一次性全部引入Vant时打开，默认不打开，省流量
// import Vant from 'vant';
// import 'vant/lib/index.css';

// Vue.use(Vant);

// 通用弹框组件实现
Vue.use(Alert);

// 加载框实现
Vue.use(Loading);

// 埋点配置
JSSDK.setConfig({
  // environment: 'fat',
  environment: process.env.VUE_APP_RUN_ENV,

  // debug模式, 可选值:error / debug。调试阶段，可以在console查看打印信息
  logLevel: 'error',

  // histroy模式
  history: true,

  urlParams: true,
});

track.setDefaults();

Vue.prototype.$sdk = JSSDK;

Vue.config.productionTip = false;

// 数据接口
Vue.prototype.$httpApi = api;

// http请求方法
Vue.prototype.$http = http;

// 工具方法
Vue.prototype.$utils = utils;

// hook
Vue.prototype.$hook = service.Hookable;

// 点击body点击事件监听
document.body.addEventListener('click', () => {
  Vue.prototype.$hook.callHook('hook__body-click');
});

new Vue({
  router,
  // store,
  render: h => h(App),
}).$mount('#app');
